import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Paper,
  Dialog,
  MenuItem,
  TextField,
  DatePicker,
  TimePicker,
  FlatButton,
  SelectField,
  RaisedButton
} from 'material-ui'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import ActionInfo from 'material-ui/svg-icons/action/info'
import IconButton from 'material-ui/IconButton'
import Checkbox from 'material-ui/Checkbox'
import moment from 'moment'
import { HistoryDetails } from './HistoryDetails'
import Constants from '../../utils/CommonConstants'
import { instance } from '../../lib/api'
import { DeveloperDetails } from '../../components/Common/DeveloperDetails'
import Documents from '../../components/Documents/Documents'
import UploadDocuments from './UploadDocuments'
import DocLink from '../../components/Common/DocLink'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR
} from '../../actions/loading'

const styleCss = {
  paperWrapper: {
    marginTop: 5,
    marginBottom: 5,
    padding: 5
  },
  columnWrap: {
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  }
}
const iconStyle = {
  width: '25px',
  height: '25px',
  verticalAlign: 'middle',
  padding: 0
}
const btnStyle = {
  margin: 12
}

export default class TermsheetOrderDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      orderDetails: props.order,
      documents: [],
      isReadOnly: props.reasonList.length === 0 || props.isSalesRoleOnly,
      showCustomPackageProductsDetails: false,
      customPackageProductsDetail: null,
      notes: ''
    }
    this.handleTermsheetDetailsChange =
      this.handleTermsheetDetailsChange.bind(this)
    this.getCustomPackageProductsInfo =
      this.getCustomPackageProductsInfo.bind(this)
    this.handleCommentNotesChange = this.handleCommentNotesChange.bind(this)
    this.uploadDocumentsSuccess = this.uploadDocumentsSuccess.bind(this)
    this.toggelUploadDocuments = this.toggelUploadDocuments.bind(this)
    this.handleCommentsChange = this.handleCommentsChange.bind(this)
    this.showDeveloperDetails = this.showDeveloperDetails.bind(this)
    this.handleFollowupDate = this.handleFollowupDate.bind(this)
    this.openDocumentsModal = this.openDocumentsModal.bind(this)
    this.handleFollowupTime = this.handleFollowupTime.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
    this.updateCheck = this.updateCheck.bind(this)
    this.showDocuments = this.showDocuments.bind(this)
    this.showModal = this.showModal.bind(this)
    this.submit = this.submit.bind(this)
  }

  handleCommentsChange(event, index, value) {
    this.setState({
      _reason: value,
      followupRequired:
        Constants.followupStatus.indexOf(value.nextStatusId) !== -1
          ? Constants.configMsgs.required
          : null
    })
  }

  getInvoiceUrl = (media, mediaLink = 'absoluteUrl') => {
    if (media && media.length) {
      return media[0][mediaLink]
    }
    return media
  }

  handleTermsheetDetailsChange(key, value) {
    let { orderDetails } = this.state
    orderDetails.termSheetDetails[key] = value
    this.setState({
      orderDetails
    })
  }

  handleFollowupDate(event, date) {
    this.setState({
      followUpDate: date
    })
  }

  handleFollowupTime(event, date) {
    this.setState({
      followUpTime: date
    })
  }

  handleCommentNotesChange(key, value) {
    this.setState({
      notes: value
    })
  }

  updateCheck() {
    this.setState(oldState => {
      let { orderDetails } = oldState
      orderDetails.termSheetDetails.isFinal =
        !orderDetails.termSheetDetails.isFinal
      return {
        orderDetails
      }
    })
  }

  toggelUploadDocuments() {
    this.setState({
      isUploadDocuments: !this.state.isUploadDocuments
    })
    if (this.docsUploaded) {
      this.docsUploaded = false
      this.showDocuments()
    }
  }

  handleModalClose() {
    this.setState({
      showModal: '',
      showCustomPackageProductsDetails: false,
      customPackageProductsDetail: null,
      isUploadDocuments: false
    })
  }

  showModal(modal) {
    this.setState({
      showModal: modal
    })
  }

  openDocumentsModal() {
    this.showModal('documents')
  }

  openDeveloperModal() {
    this.showModal('developer')
  }

  componentWillReceiveProps(nextProps) {
    let orderId = this.props.order.rcmOrder.id
    let { accountId } = this.props.order.termSheetDetails
    if (nextProps.documents[orderId] && !this.props.documents[orderId]) {
      this.setState(
        {
          documents: nextProps.documents[orderId]
        },
        this.openDocumentsModal
      )
    }
    if (
      nextProps.developerDetails[accountId] &&
      !this.props.developerDetails[accountId]
    ) {
      this.setState(
        {
          developer: nextProps.developerDetails[accountId]
        },
        this.openDeveloperModal
      )
    }
    if (nextProps.reasonList !== this.props.reasonList) {
      this.setState({
        isReadOnly:
          nextProps.reasonList.length === 0 || nextProps.isSalesRoleOnly
      })
    }
    if (nextProps.order !== this.props.order) {
      this.setState({
        orderDetails: nextProps.order,
        documents: [],
        isReadOnly:
          nextProps.reasonList.length === 0 || nextProps.isSalesRoleOnly,
        showCustomPackageProductsDetails: false,
        customPackageProductsDetail: null,
        notes: '',
        _reason: null,
        isUploadDocuments: false,
        followUpDate: undefined,
        followUpTime: undefined,
        followupRequired: null
      })
    }
  }

  showDeveloperDetails() {
    let { accountId } = this.props.order.termSheetDetails
    const { getDeveloperDetails } = this.props
    if (this.props.developerDetails[accountId]) {
      this.setState(
        {
          developer: this.props.developerDetails[accountId]
        },
        this.openDeveloperModal
      )
    } else {
      getDeveloperDetails(accountId)
    }
  }

  showDocuments() {
    let { id, termsheetId, caseSubTypeId } = this.props.order.rcmOrder
    const { dispatch, getOrderDocuments } = this.props
    if (this.props.documents[id]) {
      this.setState(
        {
          documents: this.props.documents[id]
        },
        this.openDocumentsModal
      )
    } else {
      getOrderDocuments(id, termsheetId, 'Termsheet', caseSubTypeId)
    }
  }

  uploadDocumentsSuccess() {
    let { id } = this.props.order.rcmOrder
    this.props.deleteOrderDocuments(id)
    this.docsUploaded = true
  }

  getProformaInvoice(milestone) {
    let proformaInvoice = false,
      proformaDigislateInvoice = false
    if (
      milestone &&
      milestone.invoiceDetails &&
      milestone.invoiceDetails.length
    ) {
      milestone.invoiceDetails.forEach(invoice => {
        if (invoice.media && invoice.media.length) {
          invoice.media.forEach(media => {
            if (
              media.objectMediaTypeName === 'Proforma Digislate Invoice' &&
              (!proformaDigislateInvoice ||
                proformaDigislateInvoice.id < media.id)
            ) {
              proformaDigislateInvoice = media
            } else if (
              media.objectMediaTypeName === 'Proforma Invoice' &&
              (!proformaInvoice || proformaInvoice.id < media.id)
            ) {
              proformaInvoice = media
            }
          })
        }
      })
    }
    return [proformaInvoice, proformaDigislateInvoice]
  }

  submit() {
    if (!this.state.orderDetails.rcmOrder.agentId) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'This Order is Unassigned'
      })
      return
    }
    const reasonID = this.state._reason ? this.state._reason.id : null
    const termSheetDetails = this.state.orderDetails.termSheetDetails
    const rcmOrder = this.state.orderDetails.rcmOrder
    const putData = {
      rcmOrder,
      termSheetDetails
    }
    if (!reasonID) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Please select a reason.'
      })
      return
    }
    const followuptime = moment(this.state.followUpDate)
    if (this.state.followUpDate && this.state.followUpTime) {
      const time = moment(this.state.followUpTime)
      followuptime.set({ hour: time.get('hour'), minute: time.get('minute') })
    } else if (
      Constants.followupStatus.indexOf(this.state._reason.nextStatusId) !== -1
    ) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Please select followup Date and Time.'
      })
      return
    }
    putData.rcmOrder.fupTime = this.state.followUpDate
      ? followuptime.valueOf()
      : null
    putData.reasonId = reasonID ? reasonID : null
    putData.notes = this.state.notes
    const url = Constants.configUrls.TERMSHEET_PUT()
    this.props.putHandler(putData, url)
  }

  getCustomPackageProductsInfo(pkg) {
    let { customProductsDetails } = pkg
    customProductsDetails =
      customProductsDetails && JSON.parse(customProductsDetails)
    if (customProductsDetails && customProductsDetails.length) {
      return (
        <React.Fragment>
          &nbsp;
          <IconButton
            style={iconStyle}
            onClick={() =>
              this.setState({
                showCustomPackageProductsDetails: true,
                customPackageProductsDetail: customProductsDetails
              })
            }
          >
            <ActionInfo color='rgb(0, 188, 212)' />
          </IconButton>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  render() {
    const {
      orderDetails,
      isUploadDocuments,
      isReadOnly,
      showCustomPackageProductsDetails,
      customPackageProductsDetail
    } = this.state
    const { termSheetDetails, rcmOrder } = orderDetails
    const { notes } = this.state
    const isRcmAdmin = this.props.isRcmAdmin
    let orderType
    switch (rcmOrder.caseSubTypeId) {
      case Constants.CaseSubTypeMap.BROKER.TERMSHEET:
        orderType = 'Broker'
        break
      case Constants.CaseSubTypeMap.DEVELOPER.TERMSHEET:
        orderType = 'Developer'
        break
      case Constants.CaseSubTypeMap.MAKAAN.TERMSHEET:
        orderType = 'Makaan'
        break
      default:
        orderType = false
    }
    return (
      <div>
        <section className='order-rcm-info clearfix'>
          {orderType && (
            <div className='col-xs-12 ta-c'>{orderType} Temsheet</div>
          )}
          <div className='col-xs-6 col-md-3'>
            <p className='lg-info'>
              <strong>Termsheet Number: </strong>
              {termSheetDetails ? termSheetDetails.number : '----------'}
            </p>
            <p className='sm-info'>
              ({this.props.caseStatusMap[rcmOrder.statusId]})
            </p>
          </div>
          <div className='col-xs-6'>
            <p className='lg-info'>{termSheetDetails.ramUser.fullName}</p>
          </div>
          <div className='col-xs-6 col-md-3'>
            <p className='lg-info'>
              {termSheetDetails.ramUser.contactNumbers.length
                ? termSheetDetails.ramUser.contactNumbers[0].contactNumber
                : '----------'}
            </p>
            <p className='sm-info'>
              {orderDetails.cityName ? orderDetails.cityName : '----------'}
            </p>
          </div>
        </section>
        <div className='container-fluid' style={{ paddingBottom: '60px' }}>
          <Paper zDepth={1} style={styleCss.paperWrapper}>
            <div className='container-fluid'>
              <div className='row box-wrap'>
                <p>Opportunity Details</p>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Opportunity Id'
                    floatingLabelText='Opportunity Id'
                    value={termSheetDetails.opportunityId || ''}
                    disabled
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Deal Amount'
                    floatingLabelText='Deal Amount'
                    type='number'
                    value={termSheetDetails.salesPrice || ''}
                    disabled
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Opportunity Name'
                    floatingLabelText='Opportunity Name'
                    disabled
                    value={termSheetDetails.opportunityName || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Termsheet Number'
                    floatingLabelText='Termsheet Number'
                    disabled
                    value={termSheetDetails.number || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='GST'
                    floatingLabelText='GST'
                    type='number'
                    disabled
                    value={termSheetDetails.gst || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='No. of Milestones'
                    floatingLabelText='No. of Milestones'
                    type='number'
                    disabled
                    value={
                      (termSheetDetails.milestoneDetails &&
                        termSheetDetails.milestoneDetails.length) ||
                      0
                    }
                  />
                </div>
              </div>
              <div className='row box-wrap'>
                <p>Opportunity Package Details:</p>
                <Table onRowSelection={this.handleRowSelection}>
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn>Name</TableHeaderColumn>
                      <TableHeaderColumn>Sales Price</TableHeaderColumn>
                      <TableHeaderColumn>Quantity</TableHeaderColumn>
                      <TableHeaderColumn>City</TableHeaderColumn>
                      <TableHeaderColumn>Start Date</TableHeaderColumn>
                      <TableHeaderColumn>Duration (In Days)</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {termSheetDetails.termsheetOpportunityPackageMappingDetails.map(
                      (pkg, index) => {
                        return (
                          <TableRow key={index}>
                            <TableRowColumn>{pkg.packageName}</TableRowColumn>
                            <TableRowColumn>{pkg.salesPrice}</TableRowColumn>
                            <TableRowColumn>
                              {pkg.quantity}
                              {this.getCustomPackageProductsInfo(pkg)}
                            </TableRowColumn>
                            <TableRowColumn>{pkg.cityName}</TableRowColumn>
                            <TableRowColumn>
                              {moment(pkg.startDate).format(
                                Constants.DATE_FORMAT
                              )}
                            </TableRowColumn>
                            <TableRowColumn>{pkg.promotedDays}</TableRowColumn>
                          </TableRow>
                        )
                      }
                    )}
                  </TableBody>
                </Table>
              </div>
              <div className='row box-wrap'>
                <p>Milestones:</p>
                <Table onRowSelection={this.handleRowSelection}>
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn>Name</TableHeaderColumn>
                      <TableHeaderColumn>Amount</TableHeaderColumn>
                      <TableHeaderColumn>Digislate Amount</TableHeaderColumn>
                      <TableHeaderColumn>Invoice Start Date</TableHeaderColumn>
                      <TableHeaderColumn>Proforma Invoice</TableHeaderColumn>
                      <TableHeaderColumn>
                        Proforma Digislate Invoice
                      </TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {termSheetDetails.milestoneDetails.map((ms, index) => {
                      const [proformaInvoice, proformaDigislateInvoice] =
                        this.getProformaInvoice(ms)
                      return (
                        <TableRow key={index}>
                          <TableRowColumn>{ms.name}</TableRowColumn>
                          <TableRowColumn>{ms.amount}</TableRowColumn>
                          <TableRowColumn>{ms.digislateAmount}</TableRowColumn>
                          <TableRowColumn>
                            {moment(ms.startDate).format(Constants.DATE_FORMAT)}
                          </TableRowColumn>
                          <TableRowColumn style={styleCss.columnWrap}>
                            {proformaInvoice && (
                              <DocLink url={proformaInvoice.absoluteUrl} />
                            )}
                          </TableRowColumn>
                          <TableRowColumn style={styleCss.columnWrap}>
                            {proformaDigislateInvoice && (
                              <DocLink
                                url={proformaDigislateInvoice.absoluteUrl}
                              />
                            )}
                          </TableRowColumn>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
              {termSheetDetails.digislateTaxInvoiceDetails &&
                termSheetDetails.digislateTaxInvoiceDetails.length > 0 && (
                  <div className='row box-wrap'>
                    <p>Digislate Tax Invoice Details</p>
                    <Table>
                      <TableHeader
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                      >
                        <TableRow>
                          <TableHeaderColumn>Invoice Number</TableHeaderColumn>
                          <TableHeaderColumn>Created At</TableHeaderColumn>
                          <TableHeaderColumn>
                            Digislate Amount
                          </TableHeaderColumn>
                          <TableHeaderColumn>Type</TableHeaderColumn>
                          <TableHeaderColumn>Invoice Link</TableHeaderColumn>
                          <TableHeaderColumn>
                            Credit Note Link
                          </TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody displayRowCheckbox={false}>
                        {termSheetDetails.digislateTaxInvoiceDetails.map(
                          (invoice, index) => {
                            if (!isRcmAdmin && index > 0) {
                              return <React.Fragment />
                            }
                            const creditNoteMediaUrl = this.getInvoiceUrl(
                              invoice.creditNoteDetails,
                              'mediaLink'
                            )
                            const mediaUrl = this.getInvoiceUrl(invoice.media)
                            return (
                              <TableRow key={index}>
                                <TableRowColumn>
                                  {invoice.invoiceNumber}
                                </TableRowColumn>
                                <TableRowColumn>
                                  {moment(invoice.createdAt).format(
                                    Constants.DATE_FORMAT
                                  )}
                                </TableRowColumn>
                                <TableRowColumn>
                                  {invoice.otherAmount ||
                                    invoice.digislateAmount}
                                </TableRowColumn>
                                <TableRowColumn>
                                  {invoice.type === 'Tax'
                                    ? 'Tax Invoice'
                                    : 'Digislate Invoice'}
                                </TableRowColumn>
                                <TableRowColumn>
                                  {mediaUrl ? <DocLink url={mediaUrl} /> : '-'}
                                </TableRowColumn>
                                <TableRowColumn>
                                  {creditNoteMediaUrl ? (
                                    <DocLink url={creditNoteMediaUrl} />
                                  ) : (
                                    '-'
                                  )}
                                </TableRowColumn>
                              </TableRow>
                            )
                          }
                        )}
                      </TableBody>
                    </Table>
                  </div>
                )}
              <div className='row box-wrap box-grey'>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Comment</label>
                  </div>
                  <div className='col-md-9 col-xs-8'>
                    <SelectField
                      value={this.state._reason}
                      onChange={this.handleCommentsChange}
                      hintText={'Select Comment'}
                      disabled={isReadOnly}
                      fullWidth
                    >
                      {this.props.reasonList.map(reason => {
                        return (
                          <MenuItem
                            value={reason}
                            key={reason.id}
                            primaryText={reason.label}
                          />
                        )
                      })}
                    </SelectField>
                  </div>
                </div>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Followup Date</label>
                  </div>
                  <div className='row col-md-9 col-xs-8'>
                    <div className='col-xs-6 col-md-4'>
                      <DatePicker
                        hintText='Followup Date'
                        disabled={isReadOnly}
                        minDate={moment().toDate()}
                        value={this.state.followUpDate}
                        onChange={this.handleFollowupDate}
                        errorText={
                          this.state.followUpDate
                            ? null
                            : this.state.followupRequired
                        }
                      />
                    </div>
                    <div className='col-xs-6 col-md-4'>
                      <TimePicker
                        format='ampm'
                        disabled={isReadOnly}
                        minutesStep={5}
                        hintText='Followup Time'
                        errorText={
                          this.state.followUpTime
                            ? null
                            : this.state.followupRequired
                        }
                        onChange={this.handleFollowupTime}
                        value={this.state.followUpTime}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Notes</label>
                  </div>
                  <div className='col-md-9 col-xs-8'>
                    <TextField
                      hintText='Notes'
                      disabled={isReadOnly}
                      value={notes}
                      onChange={this.handleCommentNotesChange}
                      fullWidth
                    />
                  </div>
                </div>
                <div className='col-xs-12 text-center'>
                  <RaisedButton
                    label='Submit'
                    primary
                    disabled={isReadOnly}
                    style={btnStyle}
                    onClick={this.submit}
                  />
                </div>
              </div>
              <section className='footer-fixed-actions'>
                <div
                  className='footer-action-item'
                  onClick={this.showDeveloperDetails}
                >
                  Developer Details
                </div>
                <div
                  className='footer-action-item'
                  onClick={this.showDocuments}
                >
                  Documents
                </div>
                <div
                  className='footer-action-item'
                  onClick={() => this.showModal('history')}
                >
                  History
                </div>
              </section>
            </div>
          </Paper>
          <Dialog
            title='Developer Details'
            actions={
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            }
            modal={false}
            open={this.state.showModal === 'developer'}
            onRequestClose={this.handleModalClose}
          >
            {this.state.developer ? (
              <DeveloperDetails details={this.state.developer} />
            ) : (
              <p>Developer Details not available.</p>
            )}
          </Dialog>
          <Dialog
            title='Documents Details'
            actions={[
              <FlatButton
                label={isUploadDocuments ? 'Done Upload' : 'Upload Documents'}
                disabled={isReadOnly}
                primary
                onClick={this.toggelUploadDocuments}
              />,
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            ]}
            modal={false}
            open={this.state.showModal === 'documents'}
            autoScrollBodyContent
            onRequestClose={this.handleModalClose}
          >
            {isUploadDocuments ? (
              <UploadDocuments
                orderType={rcmOrder.caseSubTypeId}
                orderId={rcmOrder.termsheetId}
                onUploadSuccess={this.uploadDocumentsSuccess}
                objectType={'Termsheet'}
                docTypes={Constants.documentTypes.TERMSHEET}
                dispatch={this.props.dispatch}
              />
            ) : this.state.documents &&
              Object.keys(this.state.documents).length ? (
              <Documents documents={this.state.documents} />
            ) : (
              <p>Documents Details not available.</p>
            )}
          </Dialog>

          <Dialog
            title='History Details'
            autoScrollBodyContent
            actions={
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            }
            modal={false}
            open={this.state.showModal === 'history'}
            onRequestClose={this.handleModalClose}
          >
            {rcmOrder.actions && rcmOrder.actions.length ? (
              <HistoryDetails
                caseActions={rcmOrder.actions}
                caseStatusMap={this.props.caseStatusMap}
              />
            ) : (
              <p>History Details not available.</p>
            )}
          </Dialog>
          <Dialog
            title='Custom Product Details'
            autoScrollBodyContent
            actions={
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            }
            modal={false}
            open={showCustomPackageProductsDetails}
            onRequestClose={this.handleModalClose}
          >
            {customPackageProductsDetail &&
            customPackageProductsDetail.length ? (
              <Table>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                  <TableRow>
                    <TableHeaderColumn>Name</TableHeaderColumn>
                    <TableHeaderColumn>Description</TableHeaderColumn>
                    <TableHeaderColumn>Price</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                  {customPackageProductsDetail.map((prod, index) => {
                    return (
                      <TableRow key={index}>
                        <TableRowColumn>{prod.name}</TableRowColumn>
                        <TableRowColumn>{prod.description}</TableRowColumn>
                        <TableRowColumn>{prod.price}</TableRowColumn>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            ) : (
              <p>Products detail not available.</p>
            )}
          </Dialog>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/OrderDetails/TermsheetOrderDetails.js
 **/